import { MutationTree } from 'vuex'
import { IAppState } from '@/store/app'
import {
  Types,
  Layout,
  Loading,
  Progress,
  Errors,
  Drawer,
  Alert,
  Current,
  Redirect,
  Toolbar,
  Extension,
  From,
  Back,
  Bottom,
  Initialize,
  Signup,
  BottomHeight,
  HeaderHeight,
  Observer,
  Updated
} from '@/store/app/types'

const mutations: MutationTree<IAppState> = {
  [Types.layout]: (state, action: Layout) => {
    state.layout = action.payload
  },

  [Types.loading]: (state, action: Loading) => {
    state.loading = action.payload
  },

  [Types.signup]: (state, action: Signup) => {
    state.signup = action.payload
  },

  [Types.progress]: (state, action: Progress) => {
    state.progress = action.payload
  },

  [Types.errors]: (state, action: Errors) => {
    state.errors = action.payload === null ? {} : action.payload
  },

  [Types.drawer]: (state, action: Drawer) => {
    state.drawer = action.payload
  },

  [Types.alert]: (state, action: Alert) => {
    state.alert = action.payload
  },

  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },

  [Types.redirect]: (state, action: Redirect) => {
    state.redirect = action.payload
  },

  [Types.from]: (state, action: From) => {
    state.from = action.payload
  },

  [Types.back]: (state, action: Back) => {
    state.back = action.payload
  },

  [Types.toolbar]: (state, action: Toolbar) => {
    state.toolbar = action.payload
  },

  [Types.extension]: (state, action: Extension) => {
    state.extension = action.payload
  },

  [Types.initialize]: (state, action: Initialize) => {
    state.initialize = action.payload
  },

  [Types.bottom]: (state, action: Bottom) => {
    state.bottom = action.payload
  },

  [Types.bottomHeight]: (state, action: BottomHeight) => {
    state.bottomHeight = action.payload
  },

  [Types.headerHeight]: (state, action: HeaderHeight) => {
    state.headerHeight = action.payload
  },

  [Types.observer]: (state, action: Observer) => {
    state.observer = action.payload
  },

  [Types.updated]: (state, action: Updated) => {
    state.updated = action.payload
  }
}

export default mutations
